import React, { useState } from 'react';
import InputTextNested from '../../../Components/Form/InputTextNested';
import HandleUploadCertificate from './UploadHandler.component';

const AddCertificate = () => {
  const [newCertificate, setNewCertificate] = useState({
    courseName: '',
    certificateFile: null,
    dateTaken: '',
    expiryDate: '',
  });

  return (
    <>
      <h3>Add a certificate</h3>
      {/* Course Name */}
      <InputTextNested
        title="Course Name"
        label="Course Name"
        value={newCertificate.courseName}
        onChange={(e) =>
          setNewCertificate({ ...newCertificate, courseName: e.target.value })
        }
        placeholder="Enter the name of the course"
        required={true}
      />
      {/* Upload the certificate */}
      <InputTextNested
        title="Upload Certificate"
        label="Upload Certificate"
        type="file"
        onChange={(e) =>
          setNewCertificate({
            ...newCertificate,
            certificateFile: e.target.files[0],
          })
        }
        required={true}
      />
      {/* Date Taken */}

      <div>
        <label>Taken On:</label>
        <input
          type="date"
          value={newCertificate.dateTaken}
          onChange={(e) =>
            setNewCertificate((prev) => ({
              ...prev,
              dateTaken: e.target.value,
            }))
          }
          required
        />
      </div>

      {/* Expiry Date */}
      <div>
        <label>Expiry Date:</label>
        <input
          type="date"
          value={newCertificate.expiryDate}
          onChange={(e) =>
            setNewCertificate((prev) => ({
              ...prev,
              expiryDate: e.target.value,
            }))
          }
        />
      </div>
      <HandleUploadCertificate
        newCertificate={newCertificate}
        setNewCertificate={setNewCertificate}
      />
    </>
  );
};

export default AddCertificate;
